import type { User, Viewer } from '@gobingebox/shared';
import { apiFetch } from '@/lib/api';

export interface SignupInput {
  email: string;
  password: string;
  displayName: string;
  birthdate: string; // YYYY-MM-DD
}

export interface AuthResult {
  user: User;
  needsVerification?: boolean;
  /** Verification link returned when email delivery isn't configured yet. */
  devLink?: string;
}

const body = (data: unknown): RequestInit => ({ method: 'POST', body: JSON.stringify(data) });

export const authApi = {
  me: () => apiFetch<Viewer>('/auth/me'),
  signup: (input: SignupInput) => apiFetch<AuthResult>('/auth/signup', body(input)),
  login: (email: string, password: string) =>
    apiFetch<{ user: User }>('/auth/login', body({ email, password })),
  logout: () => apiFetch<{ ok: boolean }>('/auth/logout', body({})),
  verifyEmail: (token: string) => apiFetch<{ ok: boolean }>('/auth/verify-email', body({ token })),
  resendVerification: () =>
    apiFetch<{ ok: boolean; alreadyVerified?: boolean; devLink?: string }>(
      '/auth/resend-verification',
      body({}),
    ),
  forgotPassword: (email: string) =>
    apiFetch<{ ok: boolean; devLink?: string }>('/auth/forgot-password', body({ email })),
  resetPassword: (token: string, password: string) =>
    apiFetch<{ ok: boolean }>('/auth/reset-password', body({ token, password })),
};
